module.exports = __webpack_public_path__ + "img/nueva_alicia_pages_all.18533c23.png";